import React from "react";
import {PageHero} from "../common/PageHero";

export const Training = () => {
    return (
        <>
            <PageHero title={'Training'}
                      badge={'Praktisch'}
                      lead={'De trainingen worden in onze club steeds verzorgd door een gediplomeerd trainer.'}/>
            <div className={'ttc-section'}>
                <article className={'ttc-card featured'}>
                    <h3 className={'ttc-card-title'}>Praktische regeling</h3>
                    <ul className={'ttc-card-list'}>
                        <li>De trainingen werken op inschrijving: als je je engageert, verwachten we dat je komt,
                            uitgezonderd heirkracht of ziekte.
                        </li>
                        <li>Trainingen gaan voor volwassenen door op woensdag, van 20u tot 21u.</li>
                        <li>Jeugdleden trainen op woensdag van 17u30 tot 19u (gevorderden enkel op uitnodiging) en
                            van 19u tot 20u (beginnertjes 6-10j). 
                            Op vrijdag van 18u30 tot 19u45 voor de beginners 10+ en van 19u45 tot 21u voor de gevorderde spelers.
                        </li>
                        <li>Tijdens de opwarming van de training werken we aan brede motorische ontwikkeling aan de hand
                            van sporten en oefeningen uit de 11 bewegingsfamilies. Meer info en onze inspiratie kan je{' '}
                            <a href={'https://www.hetbeweegspel.nl/verantwoording/'}>hier vinden</a>.
                        </li>
                        <li>We voorzien twee “trainingsblokken”, van einde augustus tot half december, en van januari
                            tot einde april.
                        </li>
                    </ul>
                </article>
            </div>
        </>
    )
}
